import { render, staticRenderFns } from "./OrbitCalendarSvg.vue?vue&type=template&id=a64f8430&scoped=true&"
import script from "./OrbitCalendarSvg.vue?vue&type=script&lang=ts&"
export * from "./OrbitCalendarSvg.vue?vue&type=script&lang=ts&"
import style0 from "./OrbitCalendarSvg.vue?vue&type=style&index=0&id=a64f8430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f8430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a64f8430', component.options)
    } else {
      api.reload('a64f8430', component.options)
    }
    module.hot.accept("./OrbitCalendarSvg.vue?vue&type=template&id=a64f8430&scoped=true&", function () {
      api.rerender('a64f8430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/cancellation/svgs/OrbitCalendarSvg.vue"
export default component.exports